import { render, staticRenderFns } from "./IbTooltip.vue?vue&type=template&id=c8793c28"
import script from "./IbTooltip.vue?vue&type=script&lang=js"
export * from "./IbTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports